
export default [

        {
            path:'/paihang',
            name:'paihang',
            component:() => import('@/views/paihang/paihang'),
            meta: {
    
                keepAlive: true, //此组件需要被缓存
                isBack:false,
            }
    
        },
        
]


// WEBPACK FOOTER //
// ./src/router/paihang.js